export default {"src":"/_next/static/media/klarda-media-logo.9bc45799.svg","height":146,"width":1036,"blurWidth":0,"blurHeight":0};